
<div class="mb-24">
  <fieldset>
    <legend class="form__label pb-8">Add the gender marker on your government ID</legend>
    <HelperText
      text="This answer is used for Trust and Safety screening purposes and will not be visible on your profile."
      customClasses="-ml-4"
    />
    <div class="inline-flex">
      <poppins-radio-button
        id="m-gender"
        v-model="form.gender"
        radioName="gender"
        labelName="M"
        radioValue="male"
        class="mr-32 my-16"
      />
      <poppins-radio-button
        id="f-gender"
        v-model="form.gender"
        labelName="F"
        radioName="gender"
        radioValue="female"
        class="mr-32 my-16"
      />
      <poppins-radio-button
        id="x-gender"
        v-model="form.gender"
        labelName="X"
        radioName="gender"
        radioValue="x"
        class="mr-32 my-16"
        @blur="validateGender"
      />
    </div>
    <HelperText v-if="hasErrors" :status="0" customClasses="-mt-8 flex relative" :text="helperText(formStatuses.gender)" />
  </fieldset>
</div>
